import { jsx as _jsx } from "react/jsx-runtime";
import isEqual from "lodash/isEqual";
import { memo, useCallback, useMemo } from "react";
import { BoardGalleryCard } from "~/components/Gallery/BoardGalleryCard/BoardGalleryCard";
import { PublicGalleryBoardAncestors } from "~/components/PublicGallery/PublicGalleryBoardAncestors";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { useIsSearchActive } from "~/hooks/search/useIsSearchActive";
import { useOpenPublicBoardInNewTab } from "~/hooks/useOpenPublicBoardInNewTab";
import { usePublicSelectionMenuOptions } from "~/hooks/usePublicSelectionMenuOptions";
import { useGoToPublicBoard } from "~/swr-hooks/boards/useGoToPublicBoard";
import { canChangeBoardCustomFields, canSeeBoardCustomFields } from "~/utils/permissions/boardPermissions";
import { canGenerateZip } from "~/utils/permissions/taskPermissions";
import { useGetPublicBoardMenuOptionsCallback } from "./useGetPublicBoardMenuOptionsCallback";
export const PublicBoardGalleryBoard = /*#__PURE__*/ memo((param)=>{
    let { data: board, box } = param;
    const { isSearchActive } = useIsSearchActive();
    const ancestors = useMemo(()=>{
        var _board_ancestors;
        return isSearchActive && !!((_board_ancestors = board.ancestors) === null || _board_ancestors === void 0 ? void 0 : _board_ancestors.length) ? /*#__PURE__*/ _jsx(PublicGalleryBoardAncestors, {
            ancestors: board.ancestors
        }) : undefined;
    }, [
        isSearchActive,
        board.ancestors
    ]);
    const { permissions } = usePublicPermissions();
    const { getSelectionMenuOptions } = usePublicSelectionMenuOptions();
    const { getBoardMenuOptionsCallback } = useGetPublicBoardMenuOptionsCallback();
    const _getItemMenuOptions = getBoardMenuOptionsCallback({
        item: board
    });
    const { goToPublicBoard } = useGoToPublicBoard();
    const { openPublicBoardInNewTab } = useOpenPublicBoardInNewTab();
    const onItemClick = useCallback(()=>goToPublicBoard(board, "board"), [
        board,
        goToPublicBoard
    ]);
    const onItemCmdClick = useCallback(()=>openPublicBoardInNewTab({
            board
        }), [
        board,
        openPublicBoardInNewTab
    ]);
    const canDownload = canGenerateZip(permissions);
    const canEditCustomFields = canChangeBoardCustomFields(permissions);
    const canViewCustomFields = canSeeBoardCustomFields(permissions);
    const isSelectable = canDownload || canEditCustomFields;
    return /*#__PURE__*/ _jsx(BoardGalleryCard, {
        board: board,
        cardWidth: box.width,
        getItemMenuOptions: _getItemMenuOptions,
        getSelectionMenuOptions: getSelectionMenuOptions,
        isSelectable: isSelectable,
        onClick: onItemClick,
        onCmdClickTitle: onItemCmdClick,
        ancestors: ancestors,
        canViewCustomFields: canViewCustomFields
    });
}, isEqual);
PublicBoardGalleryBoard.displayName = "PublicBoardGalleryBoard";
